import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ManikEntityFE } from '../manik-library/ManikEntityFE';
import { ManikEcommBase } from '../NovaEcomm/ManikEcommBase';
import { NovaBookingHandler } from '../NovaBooking/nova-booking-handler';
import { IProductVariant } from '../models/IProductVariant';
import { map, take, retry } from 'rxjs/operators';
import { ISiteFetchData, ISiteMetaData } from '../models/site-metadata';
import { IEditOptions } from '../ModelPopup/site-edit/site-edit.component';
import { ManikEntityService } from '../manik-library/ManikEntityService';
import { SiteEditComponent } from '../ModelPopup/site-edit/site-edit.component';
import { RequestOptions, Headers } from '@angular/http';
declare const google: any;
declare var WizardEnquiry: any;

export class WebSiteBase extends ManikEntityFE {
  public IsEdit: boolean = false;
  public SiteMetaData: string = '';
  public IsWebPageInitialized: boolean = false;
  public IsWebCard: boolean = false;
  public IsSmartCard: boolean = false;
  public IsSmartSite: boolean = false;
  public WebSiteMetaData: any = {};
  public BusinessID: string;
  public LoadURL: string = location.href;
  public PortalContext: string = '';
  public PortalDS: string = '';
  public BackendURL: string = '';
  public BizHandle: string = '';
  protected NovaEcomm: ManikEcommBase;
  protected BookingStore: NovaBookingHandler;
  public OnDemandDivArray: any[] = [];
  public ProductList: any[] = [];
  public VarientList: IProductVariant[] = [];
  public SiteEditOptions: IEditOptions;
  constructor(
    public httpClient: HttpClient,
    public _routeParams: ActivatedRoute,
    protected title: Title,
    public _manikEntityService: ManikEntityService
  ) {
    super(document);

    this.NovaEcomm = new ManikEcommBase(this.httpClient);
  }

  public populateControls(): void {
    sessionStorage.clear();
    let domainName = document.location.hostname;
    console.log('domainName====',domainName);
    
    console.log(domainName);
    let slug: string = this._routeParams.snapshot.params['businessslug'];
    let SiteData: any;
    let Action = location.pathname.split('/')[1];
    // domainName='mycard.instaciti.com';
    let operationMode = '';
    if (
      domainName == 'mycard.instaciti.com' ||
      domainName == 'hello.instaciti.com' ||
      domainName == 'linkup.ai'
    ) {
      operationMode = 'FETCH.MY.SIGN';
    } else if (
      domainName == 'bizcard.instaciti.com' ||
      domainName == 'hellobiz.instaciti.com' ||
      domainName == 'biz.linkup.ai' ||
      domainName == 'onelink.bigdot.ai'
    ) {
      operationMode = 'FETCH.BIZ.SIGN';
    } else if (domainName == 'hono.instaciti.com') {
      operationMode = 'FETCH.PERSONAL.SITE';
    } else {
      operationMode = 'FETCH.SIGN';
    }
    const headers = new Headers();
    headers.append('TenantID', 'INSTA.WEB');
    let options = new RequestOptions({ headers: headers });

    this._manikEntityService
      .manikWebAPIConnectGeneric(
        'https://entityserver.manikworks.com/apptoken',
        null,
        options,
        'GET'
      )
      .subscribe(
        (data) => {
          sessionStorage.setItem('ManikAuthToken', data.ManikJSon[0].JSon0);
          sessionStorage.setItem('Token', data.ManikJSon[0].JSon0);
          sessionStorage.setItem('sToken', data.ManikJSon[0].JSon0);

          const headers2 = new Headers();
          headers2.append('Operation', operationMode);
          headers2.append('DomainOrSubDomain', domainName);
          headers2.append('BusinessSlug', slug);
          headers2.append('Authorization', `Bearer ${data.ManikJSon[0].JSon0}`);

          let options1 = new RequestOptions({ headers: headers2 });
          this._manikEntityService
            .manikWebAPIConnectHttp(
              'https://entityserver.manikworks.com/website',
              null,
              options1
            )
            .subscribe((data: any) => {
              // console.log(data)
              // console.log(data.payload);

              let resp: any = data;

              console.log('resp ===================>', resp);

              this.title.setTitle(resp.Title);
              this.BusinessID = resp.BID;
              let MetaData: ISiteMetaData = {
                BizLatitude: resp.BizLatitude,
                BizLongitude: resp.BizLatitude,
                PC: resp.PC,
                BackendURL: resp.BackendURL,
                PDS: resp.PDS,
                PID: resp.PID,
                ECommServer: resp.ECommServer,
                COUNTRYID: resp.COUNTRYID,
                EC: resp.EC,
                EOLVIEW: resp.EOLVIEW,
                BID: resp.BID,
                EBID: resp.EBID,
                CID: resp.CID,
                SCID: resp.SCID,
                SubCategoryName: resp.SubCategoryName,
                BizHandle: resp.BizHandle,
                StoreHandle: resp.StoreHandle,
                ECommWorkOffline: resp.ECommWorkOffline,
              };
              if (resp.IsRTL === 'Y') {
                document.documentElement.lang = 'ar';
                document.documentElement.dir = 'rtl';
                this.document
                  .getElementById('cssBootstrap')
                  .setAttribute(
                    'href',
                    'https://cdn.rtlcss.com/bootstrap/v4.5.3/css/bootstrap.min.css'
                  );
              } else if (resp.IsRTL === 'N') {
                this.document
                  .getElementById('cssBootstrap')
                  .setAttribute(
                    'href',
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css'
                  );
              }
              sessionStorage.setItem('SiteMetaData', JSON.stringify(MetaData));
              this.PortalContext = resp.PC;
              this.PortalDS = resp.PDS;
              sessionStorage.setItem('PortalIdentifier', this.PortalContext);
              sessionStorage.setItem('PortalDS', this.PortalDS);
              this.BackendURL = resp.BackendURL;
              this.StoreHandle = resp.StoreHandle;
              this.BizHandle = resp.BizHandle;
              if (resp.IsRTL === 'Y') {
                this.document
                  .getElementById('cssBootstrap')
                  .setAttribute(
                    'href',
                    'https://cdn.rtlcss.com/bootstrap/v4.2.1/css/bootstrap.min.css'
                  );
              }
              this.WebSiteMetaData = resp;
              this.BindCSS(resp.SITECSS);
              this.BindCSS(resp.BIZCSS);
              this.BindJS(resp.SITEJS);
              this.BindJS(
                'https://www.google.com/recaptcha/api.js?render=AIzaSyBQmHKpdxsRyy-gwR6K1N7CIuOspBvzZn8'
              );

              //this.BindJS("./assets/script/Manik_Tran.js");
              if (resp.EOLVIEW === 'WEBCARD') {
                this.IsWebCard = true;
                setTimeout(
                  () => document.getElementById('openModalButton').click(),
                  5000
                );
              } else if (resp.EOLVIEW === 'SMARTCARD') {
                this.IsSmartCard = true;
                setTimeout(
                  () => document.getElementById('openModalButton').click(),
                  5000
                );
              } else {
                this.IsSmartSite = true;
              }
              setTimeout(() => {
                this.SiteMetaData = resp.PageHTML;
                this.IsWebPageInitialized = true;
                setTimeout(() => {
                  let arr = this.document.getElementsByTagName('manikph');
                  for (let i = 0; i < arr.length; i++) {
                    let body: any = {};
                    body['id'] = arr[i].id;
                    body['html'] = arr[i].innerHTML;
                    let attributes = arr[i].attributes;
                    if (attributes['pgheader'])
                      body['pgheader'] = attributes['pgheader'].value;
                    if (attributes['targetcontrol'])
                      body['targetcontrol'] = attributes['targetcontrol'].value;
                    this.OnDemandDivArray.push(body);
                  }

                  for (let index = arr.length - 1; index >= 0; index--) {
                    arr[index].parentNode.removeChild(arr[index]);
                  }

                  this.BindJS('./assets/script/Smartsite.js');
                  if (this.StoreHandle) {
                    let IsOnline: boolean = true;
                    if (IsOnline) this.NovaEcomm.Online_FetchStoreInformation();
                    else this.NovaEcomm.PopulateOnlineStore();
                  }

                  // if (Action === "edit") {
                  //   this.IsEdit = true;
                  //   // if (decodedToken.role === "BUSINESS.OWNER") {
                  //   this.BindCSS(resp.EDITCSS);
                  //   this.BindJS(resp.EDITJS);
                  //   this.BindJS("./assets/script/smart-site.edit.js");
                  //   this.BindCSS("./node_modules/@angular/material/prebuilt-themes/indigo-pink.css");
                  //   this.document.getElementById("hfIsEdit").value = "Y";
                  //   this.SiteEditOptions = {
                  //     Type: "MENU",
                  //     BusinessHandle: this.BizHandle,
                  //     BusinessID: this.BusinessID,
                  //     PortalContext: this.PortalContext,
                  //     PortalDS: this.PortalDS
                  //   };

                  //   this._manikEntityService.setData(this.SiteEditOptions);
                  // }

                  this.initMap(
                    parseFloat(resp.BizLatitude),
                    parseFloat(resp.BizLongitude)
                  );
                  this.BindSocialMedia();

                  if (this.BizHandle) {
                    // this.BookingStore = new NovaBookingHandler(this._manikEntityService, this.document);
                    // this.BookingStore.PopulateOnlineBookingStore(this.BizHandle);
                    setTimeout(() => {
                      this.BindJS('./assets/script/Manik_Booking.js');
                    }, 1000);
                  }
                }, 100);
              }, 100);

              this.BindJS('./assets/script/BusinessEnquiery.js');
              // });
              setTimeout(() => {
                WizardEnquiry();
              }, 500);
            });
        },
        (error) => {}
      );
  }

  initMap(_lat, _long) {
    var position = { lat: _lat, lng: _long };
    var map = new google.maps.Map(document.getElementById('googleMap'), {
      zoom: 12,
      center: position,
    });
    var marker = new google.maps.Marker({ position: position, map: map });
  }

  BindSocialMedia() {
    try {
      let portalURL = window.location.href;
      this.document
        .getElementById('fbShare')
        .setAttribute(
          'href',
          'https://www.facebook.com/sharer/sharer.php?u=' + portalURL
        );
      this.document
        .getElementById('googleShare')
        .setAttribute('href', 'https://plus.google.com/share?url=' + portalURL);
      this.document
        .getElementById('linkeindShare')
        .setAttribute(
          'href',
          'https://www.linkedin.com/shareArticle?url=' + portalURL
        );
      this.document
        .getElementById('lnkTwiter')
        .setAttribute(
          'href',
          'https://twitter.com/intent/tweet?url=' + portalURL
        );
    } catch (exception) {}
  }
}
